import { render, staticRenderFns } from "./CalculationBlockBase.vue?vue&type=template&id=54151ebf&scoped=true&"
import script from "./CalculationBlockBase.vue?vue&type=script&lang=js&"
export * from "./CalculationBlockBase.vue?vue&type=script&lang=js&"
import style0 from "./CalculationBlockBase.vue?vue&type=style&index=0&id=54151ebf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54151ebf",
  null
  
)

export default component.exports